// extracted by mini-css-extract-plugin
module.exports = {"cardBgColor":"__cardBgColor__Kmldq"};